


















































import Vue from 'vue';
import {ToggleComponent} from '@mobi-components/toggle';
import {AmexFilter, AmexDropdown} from '@mobi-components/amex-bluesky-components';

const NEAR_STAY = () => import('@components/svg/near-stay.vue');
const NEIGHBORHOOD = () => import('@components/svg/neighborhood.vue');
const DESTINATIONS = () => import('@components/svg/destination.vue');

enum ExploreTarget {
  DESTINATIONS = 'DESTINATIONS',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  BEYOND = 'BEYOND',
  NEAR_STAY = 'NEAR_STAY',
}

export type DayPlanItem = {
  date: Date;
  isPlanned: boolean;
  exploreTarget: string;
  id: string;
};

export type PlannedOption = {
  value: string;
  id: string;
  title: string;
};

export default Vue.extend({
  name: 'ItineraryPreferencesDayPlans',
  components: {
    ToggleComponent,
    AmexDropdown,
    AmexFilter,
  },
  props: {},
  data() {
    return {
      isActive: '0',
      daysPlan: [
        {date: new Date(), isPlanned: true, exploreTarget: ExploreTarget.NEAR_STAY, id: '1', title: 'Near Stay'},
        {date: new Date(), isPlanned: true, exploreTarget: ExploreTarget.NEIGHBORHOOD, id: '2', title: 'Neighborhood'},
        {date: new Date(), isPlanned: false, exploreTarget: ExploreTarget.DESTINATIONS, id: ' 3', title: 'Destination'},
        {date: new Date(), isPlanned: true, exploreTarget: ExploreTarget.DESTINATIONS, id: '4', title: 'Near Stay'},
        {date: new Date(), isPlanned: false, exploreTarget: ExploreTarget.NEIGHBORHOOD, id: '5', title: 'Near Stay'},
        {date: new Date(), isPlanned: true, exploreTarget: ExploreTarget.DESTINATIONS, id: '6', title: 'Near Stay'},
        {date: new Date(), isPlanned: true, exploreTarget: ExploreTarget.DESTINATIONS, id: '7', title: 'Near Stay'},
        // {date: 'Thu Apr 9', isPlanned: true, exploreTarget: ExploreTarget.DESTINATIONS, id: 8},
      ],
      plansFilterOptions: [
        {value: ExploreTarget.NEAR_STAY, title: 'Near Stay'},
        {value: ExploreTarget.NEIGHBORHOOD, title: 'Neighborhood'},
        {value: ExploreTarget.DESTINATIONS, title: 'Destination'},
        {value: ExploreTarget.DESTINATIONS, title: 'Near Stay'},
      ],
    };
  },
  methods: {
    onToggle(index: number) {
      this.$emit('toggle-plan-day');
      this.daysPlan[index].isPlanned = !this.daysPlan[index].isPlanned;
    },
    isScrollable() {
      if (this.daysPlan.length >= 8) {
        return true;
      }
      return false;
    },
    onDropDownOpen(id: string) {
      this.isActive = this.isActive === id ? '0' : id;
    },

    onPlansFilterChange(value: ExploreTarget, id: string, title: string) {
      const currentPlanIndex = this.daysPlan.findIndex((plan) => plan.id === id);
      const updatedPlans = Object.assign({}, this.daysPlan[currentPlanIndex]);
      updatedPlans.exploreTarget = value;
      updatedPlans.title = title;
      const newPlans = this.daysPlan.slice();
      newPlans[currentPlanIndex] = updatedPlans;
      this.daysPlan = newPlans;

      this.isActive = this.isActive === id ? '0' : id;
    },

    dropdownIcon(target: string) {
      if (target === 'NEAR_STAY') {
        return NEAR_STAY;
      } else if (target === 'NEIGHBORHOOD') {
        return NEIGHBORHOOD;
      } else if (target === 'DESTINATIONS') {
        return DESTINATIONS;
      } else {
        return null;
      }
    },
    convertDate(date: Date) {
      const formattedDate = date.toLocaleString('en-us', {weekday: 'short', month: 'short', day: 'numeric'});
      return formattedDate;
    },
  },
});
